// https://github.com/svivian/sv-hover-intent-js
SV=window.SV||{},SV.HoverIntent=function(){return function(a,b){const c={exitDelay:400,interval:100,sensitivity:7};let d,e,f,g,h,i,j,k={};const l=function(a,b){for(let c in b)a[c]=b[c];return a},m=function(a){d=a.pageX,e=a.pageY},n=function(a){const b=f-d,c=g-e,l=Math.sqrt(b*b+c*c);if(l<k.sensitivity){clearTimeout(j);for(let a of h)a.isActive&&(k.onExit(a),a.isActive=!1);k.onEnter(a),a.isActive=!0}else f=d,g=e,i=setTimeout(function(){n(a)},k.interval)},o=function(a,b){if(!b||!b.onEnter||!b.onExit)throw"onEnter and onExit callbacks must be provided";k=l(c,b),h=a;for(let c of h)c.isActive=!1,c.addEventListener("mousemove",m),c.addEventListener("mouseenter",function(a){return f=a.pageX,g=a.pageY,c.isActive?void clearTimeout(j):void(i=setTimeout(function(){n(c)},k.interval))}),c.addEventListener("mouseleave",function(){clearTimeout(i),c.isActive&&(j=setTimeout(function(){k.onExit(c),c.isActive=!1},k.exitDelay))})};o(a,b)}}();

// Menu Hover
new SV.HoverIntent(document.querySelectorAll('.details-disclosure > .details'), {
  onEnter: function(targetItem) {
    targetItem.setAttribute('open', true);
    targetItem.querySelector('.header__submenu')?.removeAttribute('tabindex');
  },
  onExit: function(targetItem) {
    targetItem.removeAttribute('open');
    targetItem.querySelector('.header__submenu')?.setAttribute('tabindex', '-1');
  },
  exitDelay: 400,
  interval: 100,
  sensitivity: 7,
});

function getFocusableElements(container) {
  return Array.from(
    container?.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);
  if (elementToFocus) elementToFocus.focus();
}
window.trapFocus = trapFocus;

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}
window.pauseAllMedia = pauseAllMedia;
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}
window.removeTrapFocus = removeTrapFocus;
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
window.debounce = debounce;
window.serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = 'json', method = 'POST') {
  return {
    method: method,
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
window.fetchConfig = fetchConfig;
function isMobile() {
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))
}
isMobile()
function validateEmail(email='') {
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email)
}
window.validateEmail = validateEmail;

function addInstaContainer() {
  if (document.getElementById('insta-feed')) {
    document.getElementById('insta-feed').closest('.shopify-section').classList.add('insta-container');
  }
}
addInstaContainer();

function isInViewport(el) {
  const rect = el.getBoundingClientRect();
  return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)

  );
}
window.isInViewport = isInViewport;

function getLargestVisibleChild(parentElement) {
  if(parentElement) {
    const childElements = parentElement.querySelectorAll('[data-child]');
    let largestVisibleDiv = null;
    let maxVisibleArea = 0;

    // Get viewport dimensions
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    childElements.forEach(div => {
      const rect = div.getBoundingClientRect();

      // Calculate intersection with viewport
      const visibleLeft = Math.max(0, rect.left);
      const visibleTop = Math.max(0, rect.top);
      const visibleRight = Math.min(viewportWidth, rect.right);
      const visibleBottom = Math.min(viewportHeight, rect.bottom);

      // Check if element is at least partially visible
      if (visibleLeft < visibleRight && visibleTop < visibleBottom) {
        const visibleWidth = visibleRight - visibleLeft;
        const visibleHeight = visibleBottom - visibleTop;
        const visibleArea = visibleWidth * visibleHeight;

        if (visibleArea > maxVisibleArea) {
          maxVisibleArea = visibleArea;
          largestVisibleDiv = div;
        }
      }
    });

    return largestVisibleDiv;
  }
  return null
}


/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
    this.adjustMobilePanel();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    // Origin Code Start
    // openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    // Origin Code End

    // Custom Code Start
    this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary'));
    // Custom Code End
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      // Origin code Start
      // trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      // Origin code end

      // Custom code start
      if (!detailsElement.hasAttribute('open')) {
        const detailsElements = document.querySelectorAll('.header--megamenu .menu-drawer__navigation>ul>li>details');
        if (detailsElements) {
          detailsElements.forEach(details =>  {
            if (detailsElement != details) {
              details.removeAttribute('open');
              details.classList.remove('menu-opening');
            }
          });
        }
        trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      } else {
        setTimeout(() => {
          detailsElement.setAttribute('open', '')
        });
      }
      // Custom code end

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }

  adjustMobilePanel() {
    const announcementBar = document.querySelector('#shopify-section-announcement-bar');
    const mobilePanel = document.querySelector('.header--megamenu #menu-drawer');
    const header = document.querySelector('sticky-header');
    if (mobilePanel && announcementBar) {
      mobilePanel.style.height = "calc(100vh - " + header.offsetHeight + "px - " + announcementBar.offsetHeight + "px + 1px)";
    }
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    const event = new Event('click');
    const firstSummary = document.querySelector('#menu-drawer > .menu-drawer__navigation > .menu-drawer__menu > li > details > summary');
    if (firstSummary) {
      firstSummary.dispatchEvent(event);
      firstSummary.closest('details').setAttribute('open', '');
      firstSummary.setAttribute('aria-expanded', 'true');
    }
    
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
      const clickEvent = new Event('click');
      const pierceNav = document.querySelector('.menu-drawer__navigation > ul > li:nth-child(1) > details > summary');
      if (pierceNav) {
        pierceNav.dispatchEvent(clickEvent);
        pierceNav.closest('details').setAttribute('open', '');
      }
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
    });
    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (this.querySelector('.template-popup')) this.querySelector('.template-popup').loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    if (button) {
      button.addEventListener('click', () => {
        if (document.querySelector(this.getAttribute('data-modal'))) document.querySelector(this.getAttribute('data-modal')).show(button);
      });
    }
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    if (this.querySelector('[id^="Deferred-Poster-"]')) this.querySelector('[id^="Deferred-Poster-"]').addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      pauseAllMedia();
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    if (!this.sliderItems.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItems[0].clientWidth);
    this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderItems[0].clientWidth : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

const initProductSlider = () => {
  var imagesContainer = document.querySelector('.product__media-wrapper:not(.product__media-single) .product__media-main .glide');
  if(imagesContainer) {
    var imagesSlider = null;
    function initDisableSwiper() {
      if(window.innerWidth < 990) {
        imagesSlider = new Swiper('.product__media-main [data-media-swiper]', {
          grabCursor: true,
          slidesPerView: 1,
          spaceBetween: 10,
          watchSlidesProgress: true,
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          },
          a11y: {
            slideRole: '',
            slideLabelMessage: '', 
          },
        })
      } else if (imagesSlider != null && imagesSlider.enabled) {
        imagesSlider.destroy( true, true );
        imagesSlider = null;
        imagesContainer.querySelectorAll('.swiper-slide').forEach(slide => slide.setAttribute('style', ''))
      }
    }
    initDisableSwiper();
    
    window.addEventListener('orientationchange', function(event) {
      initDisableSwiper();
    });
  
    window.addEventListener('resize', function(event) {
      initDisableSwiper();
    });
  }
  const mediaAttr = 'data-media-id'
  const thumbAttr = 'data-pdp-thumb'
  const thumbs = document.querySelectorAll(`[${thumbAttr}]`)
  const mainAttr = 'data-pdp-main-img'
  const mainImages = document.querySelectorAll(`[${mainAttr}]`)
  const activeClasses = ['border-[2px]', 'border-accent-3']
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const mediaId = thumb.getAttribute(mediaAttr)
      const mainImage = document.querySelector(`[${mainAttr}][${mediaAttr}="${mediaId}"]`)
      thumbs.forEach(t => {
        if(t == thumb) {
          t.classList.add(...activeClasses)
        } else {
          t.classList.remove(...activeClasses)
        }
      })

      window.scrollTo({
        top: mainImage.offsetTop,
        left: 0,
        behavior: "smooth",
      })
    })
  })
  window.addEventListener('scroll', () => {
    const largetChild = getLargestVisibleChild(document.querySelector(`[data-main-images-wrap]`))
    if(largetChild) {
      mainImages.forEach(mainImage => {
        const mediaId = mainImage.getAttribute(mediaAttr)
        const thumb = document.querySelector(`[${thumbAttr}][data-media-id="${mediaId}"]`)
        if(mainImage == largetChild) {
          thumb.classList.add(...activeClasses)
        } else {
          thumb.classList.remove(...activeClasses)
        }
      })
    }
  })
};

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.mainImages = Array.from(document.querySelectorAll(`.product__media-item`));
    this.thumbImages = Array.from(document.querySelectorAll(`[data-pdp-thumb]`));
    this.modalImages = Array.from(document.querySelectorAll(`.product-media-modal__content [data-media-id]`));
    this.swatches = Array.from(this.querySelectorAll(`[data-pdp-swatch]`)); 
    // this.updateTypeImages();
    this.addEventListener('change', this.onVariantChange);
    if(document.querySelector('[name="Metal"]:checked.hidden-variant') && document.querySelector('[name="Metal"]:not(.hidden-variant)')) {
      document.querySelector('[name="Metal"]:checked.hidden-variant').checked = false;
      const newInput = document.querySelector('[name="Metal"]:not(.hidden-variant)');
      newInput.checked = true;
      const newChange = new Event('change');
      newInput.dispatchEvent(newChange);
      if(document.querySelector('variant-radios')) document.querySelector('variant-radios').onVariantChange();
    }
    initProductSlider();
    this.swatches.forEach(swatch => {
      swatch.addEventListener('keyup', (e) => {
        if(e.code.toUpperCase() == 'ENTER') {
          const id = swatch.getAttribute('for');
          if(document.querySelector(`#${id}`)) document.querySelector(`#${id}`).checked = true;
          this.onVariantChange()
        }
      })
    })
  }

  onVariantChange() {
    this.productUrl = null;
    this.updateOptions();
    this.updateMasterId();
    // this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.updateWishlistVisibility();
    
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      // this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    this.swatches.forEach(swatch => {
      const id = swatch.getAttribute('for');
      // swatch.setAttribute('aria-checked', document.querySelector(`#${id}`)?.checked || false);
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      const metalFieldset = document.querySelector('.fieldset-metal.fieldset-birthstone:not(.fieldset-pairs)');
      if (metalFieldset) {
        const seletedVariants = metalFieldset.querySelector('input:checked').dataset.variants;
        this.productUrl = metalFieldset.querySelector('input:checked').dataset.productUrl;
        return !variant.options.map((option, index) => {
          return this.options[index] === option && (seletedVariants.indexOf(variant.id.toString()) > -1);
        }).includes(false);
      } else if(document.querySelector('.commit-option')) {
        const selectedIds = document.querySelector('[name="select-months"]:checked').dataset.vIds;
        return !variant.options.map((option, index) => {
          return option.indexOf(this.options[index]) > -1 && selectedIds.indexOf(variant.id.toString()) > -1;
        }).includes(false);
      } else
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
    }); 
  }

  updateImages(html) {
    if (!this.currentVariant || !html) return;
    if(this.currentVariant) {
      function getMedia(grouped, product) {
        return grouped.concat(product.media)
      }
      const media = window.currentProducts.reduce(getMedia, []);
      const currentProduct = window.currentProducts.filter(product => product.variants.map(v => v.id).includes(this.currentVariant.id))[0];

      let pMetal = currentProduct.options.includes('Metal') || currentProduct.options.includes('metal') || currentProduct.options.includes('Denominations') ? this.currentVariant.options[0]?.toLowerCase() : null;
      let pType = currentProduct.options.includes('Type') || currentProduct.options.includes('type') ? this.currentVariant.options[1]?.toLowerCase() : null;
      if(pType == null && currentProduct.tags.includes('single-pair')) {
        pType = document.querySelector('.product-form__input [name="Type"]:checked')?.value?.toLowerCase()
      }
      
      this.imagesIds = media.filter(m => {
        if(m.alt?.includes('noshow'))
          return false;
        else {
          if(pMetal) {
            if(pType) {
              const alt = (m.alt || '').toLowerCase().trim();
              const combinedAlt = `${pType}:${pMetal}`;
              const rolloverAlt = `rollover:${pMetal}`;
              const productTitle = currentProduct.title.toLowerCase();
              return (alt.includes(combinedAlt) || alt == '' || !alt || alt.includes(productTitle) || alt.includes(rolloverAlt) || alt == 'rollover');
            } else {
              const alt = (m.alt || '').toLowerCase().trim();
              const productTitle = currentProduct.title.toLowerCase();
              const formattedMetal = `:${pMetal}`;
              return (alt.includes(formattedMetal) || alt == '' || !alt || alt.includes(productTitle) || alt == 'rollover');
            }
          } else {
            return true
          }
        }
      }).map(m => m.id);
    }
    
    this.mainImages.forEach(mainImage => {
      const imageId = parseInt(mainImage.getAttribute('data-media-id') || 0);
      mainImage.classList.toggle('!hidden', !this.imagesIds?.includes(imageId))
    });
    this.thumbImages.forEach(thumbImage => {
      const imageId = parseInt(thumbImage.getAttribute('data-media-id') || 0);
      thumbImage.classList.toggle('!hidden', !this.imagesIds?.includes(imageId))
    });
    this.modalImages.forEach(modalImage => {
      const imageId = parseInt(modalImage.getAttribute('data-media-id') || 0);
      modalImage.classList.toggle('!hidden', !this.imagesIds?.includes(imageId))
    });

    // this.updateTypeImages();
  }

  // updateTypeImages() {
  //   if (document.querySelector('.fieldset-pairs') && document.querySelector('.fieldset-type')) {
  //     const newSrcs = document.querySelectorAll('.product__media-main .product__media img');
  //     const modalImages = document.querySelectorAll('.product-media-modal img');
  //     const typeValue = document.querySelector('.fieldset-type input:checked').value.toLowerCase();
  //     const reverseValue = (typeValue == 'single' ? 'pair' : 'single');
  //     newSrcs.forEach((src) => {
  //       if (src.alt.toLowerCase().includes(reverseValue))
  //         src.closest('.product__media-item').classList.add('!hidden');
  //       else
  //         src.closest('.product__media-item').classList.remove('!hidden');
  //     });
  //     modalImages.forEach((src) => {
  //       if (src.alt.includes(reverseValue))
  //         src.classList.add('!hidden');
  //       else
  //         src.classList.remove('!hidden');
  //     });
  //   }  
  // }

  updateWishlistVisibility() {
    if (!this.currentVariant) return;
    if (typeof window.triggerSwymVariantEvent != 'undefined') window.triggerSwymVariantEvent(this.currentVariant.id);
    
    const wishlistBtn = document.querySelector(`[data-main-wishlist-btn]`);
    const node = document.querySelector(`.swym-button[data-variant-id="${this.currentVariant.id}"][class*=hidden]`);
    const tempBtn = node.cloneNode(true);
    wishlistBtn.replaceWith(tempBtn);
    tempBtn.classList.add('product__wishlist--btn');
    tempBtn.classList.remove('!hidden');
    tempBtn.setAttribute('data-main-wishlist-btn', '');
    setTimeout(() => {
      tempBtn.setAttribute('aria-label', tempBtn.classList.contains('swym-added') ? 'Remove from Wishlist' : 'Add to Wishlist');
    }, 300);
    if (typeof window._swat != 'undefined' && window._swat.initializeActionButtons) window._swat.initializeActionButtons('.product__wishlist', '.product__wishlist--btn');
  }

  updateMedia() { 
    if (!this.currentVariant || !this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `.product__media-main [data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const media = document.querySelectorAll('.product__media-main .product__media-item');
    media.forEach((m) => {
      m.classList.remove('active')
    });
    newMedia.classList.add('active')
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.productUrl ? this.productUrl : this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;

      const qtyInput = productForm.querySelector('input[name="quantity"]');
      if ( qtyInput && (this.productUrl || document.querySelector('.fieldset-pairs')) && document.querySelector('.fieldset-type') ) {
        const typeValue = document.querySelector('.fieldset-type input:checked').value;
        if (typeValue == 'Pair')
          qtyInput.value = 2;
        else
          qtyInput.value = 1;
      }

      if(this.currentVariant.compare_at_price && this.currentVariant.compare_at_price > this.currentVariant.price && productForm.querySelector('[name="properties[Compare Price]"]'))
        productForm.querySelector('[name="properties[Compare Price]"]').value = `$${this.currentVariant.compare_at_price / 100.0}`;
      else if(productForm.querySelector('[name="properties[Compare Price]"]'))
        productForm.querySelector('[name="properties[Compare Price]"]').value = '';


      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    fetch(`${this.productUrl ? this.productUrl : this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) {
          destination.innerHTML = source.innerHTML;
          if ((this.productUrl || document.querySelector('.fieldset-pairs')) && document.querySelector('.fieldset-type') && document.querySelector('.fieldset-type input:checked').value == 'Pair') {
            const priceItems = document.querySelectorAll('.product__title .price .price-item');
            if (priceItems.length > 0) {
              priceItems.forEach((priceItem) => {
                let html = parseFloat(priceItem.innerHTML.trim().replace('$', ''));
                if (!isNaN(html)) {
                  html = (source.dataset.pair == true || source.dataset.pair == "true" ? 1 : 2) * html;
                  priceItem.innerHTML = `$${html}`
                }
              });
            }
          }
        }

        const productTitle = html.querySelector('[data-product-title]');
        const titleDestination = document.querySelector('[data-product-title]');

        if (this.productUrl && titleDestination && productTitle) titleDestination.innerHTML = productTitle.innerHTML;
        if (document.getElementById(`price-${this.dataset.section}`)) document.getElementById(`price-${this.dataset.section}`).classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        this.updateSwatchStatus(this.currentVariant.available);
        
        this.updateImages(html);

        const productDescription = html.querySelector('[data-pdp-desc]');
        const productDescriptionDest = document.querySelector('[data-pdp-desc]');
        if (this.productUrl && productDescription && productDescriptionDest) {
          productDescriptionDest.innerHTML = productDescription.innerHTML
        }
        const productMaterial = html.querySelector('[data-pdp-materials]');
        const productMaterialDest = document.querySelector('[data-pdp-materials]');
        if (this.productUrl && productMaterial && productMaterialDest) productMaterialDest.innerHTML = productMaterial.innerHTML;

        const inventoryLimitMsg = html.querySelector('[data-inventory-limit-msg]');
        const inventoryLimitMsgDest = document.querySelector('[data-inventory-limit-msg]');
        if (inventoryLimitMsg && inventoryLimitMsgDest) inventoryLimitMsgDest.innerHTML = inventoryLimitMsg.innerHTML;
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.querySelector(`#product-form-${this.dataset.section} [name="add"]`);
    const notifyButton = document.querySelector('.klaviyo-bis-trigger');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
      addButton.classList.add('hide');
      notifyButton.classList.remove('hide');
      notifyButton.style = '';
    } else {
      addButton.removeAttribute('disabled');
      addButton.classList.remove('hide');
      notifyButton.classList.add('hide');
      const subOptions = document.querySelector('.select-months');
      if (subOptions) {
        const checkedSub = subOptions.querySelector(':checked');
        const metal = document.querySelector('variant-radios [type="radio"]:checked').value;
        const variants = JSON.parse(checkedSub.dataset.variants);
        const variantData = variants[Object.keys(variants).filter((key) => key.indexOf(metal) > -1)[0]];

        if (variantData.subscription_duration) {
          addButton.textContent = `Shop now $${(variantData.price / 100.0)} ${variantData.savings}`
        } else {
          addButton.textContent = `SUBSCRIBE FOR $${(variantData.price / 100.0)} PER MONTH`
        }
      } else {
        addButton.textContent = window.variantStrings.addToCart;
      }
    }

    const additionalVariant = window.productVariants.filter((variant) => {
      return variant.id == this.currentVariant.id
    })[0];
    
    if (document.getElementById('presale_msg')) document.getElementById('presale_msg').remove();
    if (typeof additionalVariant != 'undefined' && additionalVariant && additionalVariant.presale_msg) {
      addButton.textContent = 'Preorder';
      var span = document.createElement("span");
      span.id = 'presale_msg';
      span.innerHTML = additionalVariant.presale_msg;
      document.querySelector('.product-form__buttons').insertBefore(span, addButton.nextSibling);
    }

    if (document.getElementById('custom_msg')) document.getElementById('custom_msg').remove();
    if (typeof additionalVariant != 'undefined' && additionalVariant && additionalVariant.custom_msg && additionalVariant.custom_msg != '') {
      var span = document.createElement("span");
      span.id = 'custom_msg';
      span.innerHTML = additionalVariant.custom_msg;
      document.querySelector('.product-form__buttons').insertBefore(span, addButton.nextSibling);
    }

    if (!modifyClass) return;
  }

  updateSwatchStatus(available) {
    const selectedSwatch = document.querySelector('variant-radios [type="radio"]:checked + .pdp-color-option');
    const otherSwatches = document.querySelectorAll('variant-radios [type="radio"]:checked + label:not(.pdp-color-option)');
    const isLookbook = document.body.classList.contains('template-product-lookbook');
    const variantTitle = document.querySelector('[data-variant-title]');
    if (selectedSwatch) {
      if (variantTitle) {
        if (selectedSwatch.previousElementSibling.dataset.metalValue)
          variantTitle.textContent = selectedSwatch.previousElementSibling.dataset.metalValue;
        else
          variantTitle.textContent = selectedSwatch.previousElementSibling.value;
      }
      
      if(!isLookbook) {
        if (available)
          selectedSwatch.classList.remove('sold-out');
        else
          selectedSwatch.classList.add('sold-out');
      }
    }
    otherSwatches.forEach((otherSwatch) => {
      if(!isLookbook) {
        if (available)
          otherSwatch.classList.remove('sold-out');
        else
          otherSwatch.classList.add('sold-out');
      }  
    });
    const birthstoneFieldset = document.querySelector('.fieldset-birthstone');
    if (birthstoneFieldset) {
      const typeBtns = document.querySelectorAll('.fieldset-type label');
      typeBtns.forEach((typeBtn) => {
        if(!isLookbook) {
          if (available)
            typeBtn.classList.remove('sold-out');
          else
            typeBtn.classList.add('sold-out');
        }    
      });  
    }
  }

  setUnavailable() {
    const addButton = document.querySelector(`#product-form-${this.dataset.section} [name="add"]`);
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    if (document.getElementById(`price-${this.dataset.section}`)) document.getElementById(`price-${this.dataset.section}`).classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
    this.swatches.forEach(swatch => {
      const id = swatch.getAttribute('for');
      // swatch.setAttribute('aria-checked', document.querySelector(`#${id}`)?.checked || false);
    });
  }
}

customElements.define('variant-radios', VariantRadios);


class ImageBanner extends HTMLElement {
  constructor() {
    super();
    this.hrefs = this.querySelectorAll('[href*="#"]');
    this.swiperWrapper = this.querySelector('[data-swiper]');
    this.slides = this.querySelectorAll('[data-banner-slide]');
    this.slideTime = parseInt(this.swiperWrapper?.getAttribute('data-autoplay-seconds') || 0);
    this.slideOn = 1;
    this.slideInterval = false;
    this.initEvents();
  }

  scrollToSlide(slides, direction, slideOn) {
    slideOn += direction;
    const activeClasses = ['!opacity-100', '!z-1', 'transition-all', 'ease-in-out', 'duration-500'];    
    if (slideOn > slides.length) slideOn = 1;
    if (slideOn < 1) slideOn = slides.length;

    slides.forEach((slide, index) => {
      if (index == slideOn - 1)
        slides[index].classList.add(...activeClasses);
      else
        slides[index].classList.remove(...activeClasses);
    })
    
    return slideOn;
  }

  initEvents() {
    this.hrefs.forEach((href) => {
      href.addEventListener('click', function(e) {
        if (typeof $ != 'undefined' && $) {
          e.preventDefault();
          $('html, body').animate({
              scrollTop: $($(this).attr('href')).offset().top - 125
          }, 700);
        }
      });
    });
    this.slides.forEach(slide => {
      slide.addEventListener('focus', () => {
        const bannerIndex = parseInt(slide.getAttribute('data-banner-slide'));
        this.slideOn = this.scrollToSlide(this.slides, 1, bannerIndex);
      })
    })
    
    if(this.slides.length > 1) {
      // if auto rotation is enabled, need to setup listeners for starting/stoping slider
      if (this.slideTime > 0) {
        this.slideInterval = setInterval(() => {
          this.slideOn = this.scrollToSlide(this.slides, 1, this.slideOn);
        }, this.slideTime * 1000);
      }
    }
    // if(this.swiperWrapper) {
    //   this.autoplay = parseInt(this.dataset.autoplay);
    //   this.swiper = new Swiper(this.swiperWrapper, {
    //     slidesPerView: 1,
    //     slidesPerGroup: 1,
    //     spaceBetween: 0,
    //     loop: true,
    //     effect: 'fade',
    //     speed: 0,
    //     pagination: false,
    //     // allowTouchMove: false,
    //     autoplay: this.autoplay == 0 ? false : { delay:  this.autoplay * 1000 },
    //   })
    // }
  }
}
customElements.define('image-banner', ImageBanner);

class ImageWithText extends HTMLElement {
  constructor() {
    super();
    this.hrefs = this.querySelectorAll('[href*="#"]');
    this.initEvents();
  }

  initEvents() {
    this.hrefs.forEach((href) => {
      href.addEventListener('click', function(e) {
        if (typeof $ != 'undefined' && $) {
          e.preventDefault();
          $('html, body').animate({
              scrollTop: $($(this).attr('href')).offset().top - 125
          }, 700);
        }
      });
    });
    if(document.querySelector('[data-section-type="piercing-banner"]')) {
      if (this.querySelector('.image-with-text__text')) this.querySelector('.image-with-text__text').classList.add('order-2', 'sm:order-1', '!mt-8', 'sm:!mt-16');
      if (this.querySelector('.image-with-text__buttons')) this.querySelector('.image-with-text__buttons').classList.add('order-1', 'sm:order-2', '!mt-8', 'sm:!mt-[1.1rem]');
    }
    if(this.querySelector('[data-media-swiper]')) {
      new Swiper(this.querySelector('[data-media-swiper]'), {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        loop: true,
        effect: 'fade',
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
        },
        autoplay: {
          delay: 6000,
        },
        a11y: {
          slideRole: '',
          slideLabelMessage: '', 
        },
      });
      if(this.querySelector('.image-with-text__responsive')) {
        const setPaginationBottom = () => {
          this.containerHeight = this.querySelector('.image-with-text__responsive').offsetHeight;
          this.swiperHeight = this.querySelector('[data-media-swiper]').offsetHeight;
          if(window.innerWidth >= 990 && this.containerHeight < this.swiperHeight) {
            this.querySelector('.swiper-pagination').style.bottom = `${(this.swiperHeight - this.containerHeight) / 2 + 40}px`
          } else {
            this.querySelector('.swiper-pagination').style.bottom = ''
          }
        }
        setTimeout(() => {
          setPaginationBottom();
          window.addEventListener('resize', () => {
            setPaginationBottom()
          });
          window.addEventListener("orientationchange", () => {
            setPaginationBottom()
          });
        }, 500);
      }
    }
  }
}
customElements.define('image-with-text', ImageWithText);

if (!customElements.get('accordion-group')) {
  customElements.define(
    'accordion-group',
    class AccordionGroup extends HTMLElement {
      constructor() {
        super()
        
        this.group    = this.querySelector('[data-accordion-group]');
        this.details  = this.group.querySelectorAll('[data-accordion-item]');
        this.toggles  = this.group.querySelectorAll(`[data-accordion-trigger]`);
        this.contents = this.group.querySelectorAll(`[data-accordion-content]`);
        
        // Set default settings if necessary
        this.settings = {
          speed: 500,
          one_visible: true
        };
        
        // Setup inital positions
        for (let i = 0; i < this.details.length; i++) {
          const detail  = this.details[i];
          const toggle  = this.toggles[i];
          const content = this.contents[i];
          
          // Set transition-duration to match JS setting
          detail.style.transitionDuration = this.settings.speed + "ms";
          
          // Set initial height to transition from
          if (!detail.hasAttribute("open")) {
            detail.style.height = toggle.clientHeight + "px";
          } else {
            detail.style.height = toggle.clientHeight + content.clientHeight + "px";
          }
        }
        
        // Setup click handler
        this.group.addEventListener("click", (e) => {
          if (e.target.classList.contains("custom-accordion-item__head") || (e.target.closest('summary') && e.target.closest('summary').classList.contains("custom-accordion-item__head"))) {
            e.preventDefault();

            let num = 0;
            for (let i = 0; i < this.toggles.length; i++) {
              if (this.toggles[i] === e.target || (e.target.closest('summary') && e.target.closest('summary') == this.toggles[i])) {
                num = i;
                break;
              }
            }

            if (!e.target.closest('details').hasAttribute("open")) {
              this.open(num);
            } else {
              this.close(num);
            }
          }
        });
      }

      open(i) {
        const detail = this.details[i];
        const toggle = this.toggles[i];
        const content = this.contents[i];
        
        // If applicable, hide all the other details first
        if (this.settings.one_visible) {
          for (let a = 0; a < this.toggles.length; a++) {
            if (i !== a) this.close(a);
          }
        }
        
        // Update class
        detail.classList.remove("is-closing");
        
        // Get height of toggle
        const toggle_height = toggle.clientHeight;
        
        // Momentarily show the contents just to get the height
        detail.setAttribute("open", true);
        const content_height = content.clientHeight;
        detail.removeAttribute("open");
        
        // Set the correct height and let CSS transition it
        detail.style.height = toggle_height + content_height + "px";
        
        // Finally set the open attr
        detail.setAttribute("open", true);
      }
      
      close(i) {
        const detail = this.details[i];
        const toggle = this.toggles[i];

        // Update class
        detail.classList.add("is-closing");
        
        // Get height of toggle
        const toggle_height = toggle.clientHeight;
        
        // Set the height so only the toggle is visible
        detail.style.height = toggle_height + "px";
        
        setTimeout(() => {
          // Check if still closing
          if (detail.classList.contains("is-closing"))
            detail.removeAttribute("open");
            detail.classList.remove("is-closing");
        }, this.settings.speed);
      }
    },
  )
}

class ProductModal extends ModalDialog {
  constructor() {
    super();
  }

  hide() {
    super.hide();
    window.pauseAllMedia();
  }

  show(opener) {
    super.show(opener);
    this.showActiveMedia();
  }

  showActiveMedia() {
    this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
        element.classList.remove('active');
      }
    )
    const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
    activeMedia.classList.add('active');
    activeMedia.scrollIntoView();
    if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template') && activeMedia.querySelector('template').content && activeMedia.querySelector('template').content.querySelector('.js-youtube'))
      activeMedia.loadContent();
  }
}

customElements.define('product-modal', ProductModal);

window.addEventListener('load', function () {
  initProductSlider()
});

const collectionNavs = document.querySelectorAll('.collection-nav');
const subsections = document.querySelectorAll('[data-subnav-section]');
const navLi = document.querySelectorAll(".collection-nav li");
const updateScrolledSection = () => {
  if(subsections.length > 0 && navLi.length > 0) {
    var current = subsections[0].getAttribute("id");

    subsections.forEach((section) => {
      const sectionTop = section.offsetTop;
      if (pageYOffset >= sectionTop - 130) {
        current = section.getAttribute("id"); }
    });
    navLi.forEach((li) => {
      li.classList.remove("collection-nav__active");
      if (li.querySelector('a').href.includes(current)) {
        li.classList.add("collection-nav__active");
      }
    });
  }
};
let first_load = false;
if (collectionNavs.length > 0) {
  const childNavs = document.querySelectorAll('.collection-nav li a');
  const plpNavInitial = (target, checkFirst = false) => {
    childNavs.forEach((nav) => {
      if(checkFirst && location.hash && location.hash != '') {
        if (nav.href.includes(location.hash))
          nav.closest('li').classList.add('collection-nav__active');
        else
          nav.closest('li').classList.remove('collection-nav__active');
      } else if(target) {
        if (nav == target)
          nav.closest('li').classList.add('collection-nav__active');
        else
          nav.closest('li').classList.remove('collection-nav__active');
      }
    });
  };
  if(location.href.includes('/collections/piercing-lookbook')) plpNavInitial(null, true);
  childNavs.forEach((childNav) => {
    childNav.addEventListener('click', (e) => {
      plpNavInitial(e.target);
      
      const href = e.target.href;
      
      if (href.includes('#') && href.split('#')[1]) {
        e.preventDefault();
        window.scrollTo({
          top: document.querySelector(`#${href.split('#')[1]}`).offsetTop - 120,
          left: 0,
          behavior: "smooth",
        });
        setTimeout(() => {
          updateScrolledSection();
        }, 700);

        // $('html, body').animate({
        //   scrollTop: $(`#${href.split('#')[1]}`).offset().top - 120
        // }, 700, function() {
        //   updateScrolledSection();
        //   if(!first_load) {
        //     setTimeout(() => {
        //       $('html, body').animate({
        //         scrollTop: $(`#${href.split('#')[1]}`).offset().top - 120
        //       }, 0);
        //     }, 500);
        //     setTimeout(() => {
        //       $('html, body').animate({
        //         scrollTop: $(`#${href.split('#')[1]}`).offset().top - 120
        //       }, 0);
        //       first_load = true;
        //     }, 1000);
        //   }
        // });
      }
    })
  })
}
if(subsections.length > 0 && navLi.length > 0) {
  window.addEventListener('scrollend', () => {
    updateScrolledSection()
  })
}

const scrollToSection = () => {
  window.scrollTo(0, document.querySelector(location.hash).offsetTop - 220);
  setTimeout(() => {
    window.scrollTo(0, document.querySelector(location.hash).offsetTop - 220);
  }, 1000)
  setTimeout(() => {
    window.scrollTo(0, document.querySelector(location.hash).offsetTop - 220);
  }, 3000)
  setTimeout(() => {
    window.scrollTo(0, document.querySelector(location.hash).offsetTop - 220);
  }, 4000)
};

if(location.hash && location.hash.includes('#') && document.querySelector(location.hash)) {
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }
  if(location.href.includes('collections/piercing-lookbook') && document.querySelector(`[data-target="${location.hash.replace('#', '')}"]`)) {
    document.querySelector(`[data-target="${location.hash.replace('#', '')}"]`).dispatchEvent(new Event('click'));
    scrollToSection();
    setTimeout(() => {
      document.querySelector(`[data-target="${location.hash.replace('#', '')}"]`).dispatchEvent(new Event('click'));
      scrollToSection();
    }, 1000);
    setTimeout(() => {
      document.querySelector(`[data-target="${location.hash.replace('#', '')}"]`).dispatchEvent(new Event('click'));
      scrollToSection();
    }, 2000);
  } else {
    scrollToSection();
  }

  // document.querySelector(location.hash).scrollIntoView();
  
}

const emailSignupTriggers = document.querySelectorAll('.klaviyo_form_trigger');
emailSignupTriggers.forEach((trigger) => {
  trigger.addEventListener('click', (e) => {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'UNnG8c']);
  })
});

const urlParams = new URLSearchParams(location.search);
const pspEmail = urlParams.get('psp_email');
if(pspEmail) {
  setTimeout(() => {
    window._learnq.push(['identify', {
      '$email' : pspEmail
    }]);
    setTimeout(() => {
      window._learnq.push(['track', 'Park Slope Parents', {
        '$email' : pspEmail,
      }]);
    }, 5000);
  }, 4000);
  history.pushState({}, "", location.href.replace(location.search, ''))
}

// Culture Map Houston
const cultureMap  = urlParams.get('culture_map_houston');
if(cultureMap) {
  gtag('event', 'culture_map_houston')
  history.pushState({}, "", location.href.replace(location.search, ''))
}

/*----------- ADA Updates ----------------*/
const pdpDetails = document.querySelector('.product__description');
if(pdpDetails) {
  pdpDetails.querySelectorAll('img').forEach(img => {
    if(!img.src) img.remove()
  })
}

const gorgiasTimer = setInterval(() => {
  const gorgiasChat = document.querySelector('iframe#chat-button');
  if(gorgiasChat) {
    clearInterval(gorgiasTimer);
    gorgiasChat.removeAttribute('role');
  }
}, 200);

// Footer Logo
const footerLogo = document.querySelector(".footer-logo");

footerLogo.addEventListener("focus", () => {
  setTimeout(() => {
    footerLogo.style = '';
  }, 100)
});

footerLogo.addEventListener("blur", () => {
  setTimeout(() => {
    footerLogo.style = '';
  }, 100)
});


var okeCounter = 0;
const okeTimer = setInterval(() => {
  // Remove roles from swiper a tag-based slides
  const hyperLinkSlides = document.querySelectorAll('.swiper-slide[href]');
  hyperLinkSlides.forEach(slide => slide.removeAttribute('role'));

  // Okendo
  const okeReviewBtn = document.querySelector('.okeReviews-reviewsWidget-header-controls-writeReview');
  if(okeReviewBtn) okeReviewBtn.setAttribute('role', 'button');

  const okendoVerifyBadges = document.querySelectorAll('.okeReviews-review-shopBadge svg');
  okendoVerifyBadges.forEach(badge => badge.setAttribute('aria-hidden', true));

  const widgetHeader = document.querySelector('.okeReviews-reviewsWidget-header');
  const parentNode = document.querySelector('.okeReviews-reviewsWidget');
  const referenceNode = document.querySelector('.okeReviews-reviewsWidget-reviews');
  if(!!widgetHeader && !!parentNode && !!referenceNode) {
    parentNode.insertBefore(widgetHeader, referenceNode);
  }
  const allyTexts = document.querySelectorAll('[data-oke-reviews-product-listing-rating] .okeReviews-a11yText');
  const reviewsCount = parseInt(document.querySelector('.okeReviews-reviewsSummary-ratingCount')?.textContent?.trim() || 0);
  allyTexts.forEach(text => {
    if(text.textContent.toLocaleLowerCase().includes('rated')) {
      const btn = document.querySelector('.okeReviews-reviewsSummary.js-okeReviews-reviewsSummary');
      btn?.setAttribute('aria-label', `${text.textContent}, ${reviewsCount} Reviews, Click to go to reviews`);
    }
    text.remove()
  });

  okeCounter += 200;
  if(okeCounter > 10000) clearInterval(okeTimer);
}, 200);

var instaCounter = 0;
const instaTimer = setInterval(() => {
  // Remove roles from swiper a tag-based slides
  const profileLogos = document.querySelectorAll('.profile-picture');
  if(profileLogos.length > 0) {
    clearInterval(instaTimer);
    profileLogos.forEach(logo => logo.setAttribute('alt', 'Instagram logo'));

    const containers = document.querySelectorAll('.instafeed-new-layout-item-container');
    containers.forEach((container, index) => {
      container.setAttribute('role', 'button');
      container.setAttribute('aria-label', `Instagram post #${index + 1} opens in a popup`);
    });
    
    const closeBtns = document.querySelectorAll('.instafeed-close-button');
    closeBtns.forEach(closeBtn => {
      closeBtn.setAttribute('role', 'button');
      closeBtn.setAttribute('aria-label', 'Close');
    });

    const slideArrows = document.querySelectorAll('.instafeed-new-arrow');
    slideArrows.forEach(slideArrow => {
      slideArrow.setAttribute('role', 'button');
    });

    const dialogs = document.querySelectorAll('.instafeed-lightbox');
    dialogs.forEach((dialog, index) => {
      dialog.setAttribute('role', 'dialog');
      dialog.setAttribute('aria-modal', 'true');
      dialog.setAttribute('aria-label', `Instagram post #${index + 1} details`);
      const innerPanel = dialog.querySelector('.lightbox-instagram');
      if(innerPanel) {
        innerPanel.removeAttribute('role');
        innerPanel.removeAttribute('aria-label');
        innerPanel.removeAttribute('aria-labelledby');
        innerPanel.removeAttribute('aria-modal');
      }
    });
  }
}, 300);

const ketchAdaTimer = setInterval(() => {
  const ketchPanel = document.querySelector('#ketch-preferences');
  const nav = document.querySelector('[data-nav1]');
  
  ketchPanel?.setAttribute('role', 'dialog');
  ketchPanel?.setAttribute('aria-label', 'Privacy center');
  if(ketchPanel) {
    if(nav) {
      nav.querySelectorAll('button > div span').forEach(span => {
        if(!!span.parentNode?.innerHTML) span.parentNode.innerHTML = span.parentNode.innerHTML.replaceAll('span', 'h4')
      })
      
      const buttons = nav.querySelectorAll('button');
      buttons.forEach(button => {
        if(!button.hasAttribute('aria-expanded')) {
          button.setAttribute('aria-expanded', 'false');
          button.addEventListener('click', () => {
            button.setAttribute('aria-expanded', !(button.getAttribute('aria-expanded') == 'true'));
          })
        }
      });
    }
    
    const backBtns = ketchPanel.querySelectorAll('[name="back"]');
    backBtns.forEach(backBtn => backBtn.setAttribute('aria-label', 'Back to purposes'));

    const logo = ketchPanel.querySelector('[class*="268px"] img');
    if(logo) logo.setAttribute('alt', 'Rowan Logo');

    const submitBtn = ketchPanel.querySelector('[type="submit"]');
    if(submitBtn && !submitBtn.hasAttribute('data-inited')) {
      submitBtn.setAttribute('data-inited', true);
      submitBtn.addEventListener('click', () => {
        setTimeout(() => {
          const form = submitBtn.closest('form');
          const errorInput = form?.querySelector('input[class*="error-outline-color"]');
          if(form && errorInput) errorInput.focus();
        }, 500);
      })
    }
  }

  const googlePrivacyLinks = document.querySelectorAll('[href="https://policies.google.com/privacy"]');
  googlePrivacyLinks.forEach(link => link.setAttribute('aria-label', 'Google Privacy Policy'));
  const googleTermsLinks = document.querySelectorAll('[href="https://policies.google.com/terms"]');
  googleTermsLinks.forEach(link => link.setAttribute('aria-label', 'Google Terms of Service'));

  const ketchPurposeSaveBtn = ketchPanel?.querySelector('button[aria-label="Save"]');
  ketchPurposeSaveBtn?.addEventListener('click', () => {
    window.showCustomMessage('Your changes saved successfully', ketchPurposeSaveBtn)
  });

  const errorInputs = ketchPanel?.querySelectorAll('input[class*="error-outline-color"]');
  errorInputs?.forEach(input => {
    const prevSibling = input.previousSibling;
    const nextSibling = input.nextSibling;
    if(nextSibling.className.includes('error-text-color') && nextSibling.textContent?.toLowerCase().includes('required')) {
      input.nextSibling.innerHTML = `${prevSibling.textContent} is required`;
      prevSibling.setAttribute('role', 'alert')
    }
  });

  const errorSelect = ketchPanel?.querySelector('select[class*="error-outline-color"]');
  if(errorSelect) {
    const parent = errorSelect.parentNode;
    const prevSibling = parent.previousSibling;
    const nextSibling = parent.nextSibling;
    if(nextSibling.className.includes('error-text-color') && nextSibling.textContent?.toLowerCase().includes('required')) {
      parent.nextSibling.innerHTML = `${prevSibling.textContent} is required`;
      prevSibling.setAttribute('role', 'alert')
    }
  }

  const errors = ketchPanel?.querySelectorAll('p.ketch-text-ketch-error') || [];
  errors.forEach(error => {
    error.setAttribute('role', 'alert');
  })

  const banner = document.querySelector('[aria-label="privacy banner"]');
  banner?.removeAttribute('aria-describedby');

  const requestSubmittedTitle = document.querySelector(`[class*="ference-tabs-requests-submitted-header-title"]`);
  requestSubmittedTitle?.setAttribute('role', 'status');

  const optLabels = document.querySelectorAll('[type="button"][data-nav] + label');
  optLabels.forEach(label => {
    const ariaLabel = label.getAttribute('aria-label');
    if(ariaLabel) {
      label.removeAttribute('aria-label');
      label.querySelector('[role="switch"]')?.setAttribute('aria-label', ariaLabel);
      label.querySelector('[role="presentation"]')?.removeAttribute('role');
      const svgs = label.querySelectorAll('svg');
      svgs.forEach(svg => {
        svg.parentElement.setAttribute('aria-hidden', 'true');
      });
    }
  });
}, 500);

// ShopPay Modal
setTimeout(() => {
  const spModal = document.querySelector('[data-nametag="shop-portal-provider"]');
  spModal?.shadowRoot?.querySelector('[data-testid="authorize-modal-header"] svg')?.setAttribute('title', 'ShopPay Logo');
  spModal?.shadowRoot?.querySelector('[aria-label="Affirm"]')?.setAttribute('title', 'Affirm Logo');
  const spModalHeader = spModal?.shadowRoot?.querySelector('[data-variant="with-title"] > div'); 
  if(spModalHeader) {
    spModalHeader.outerHTML = spModalHeader.outerHTML.replaceAll('div', 'h2')
  }
  if(spModal && document.querySelector('[data-shop-pay-style]')) {
    let styleElement = document.createElement("style");
    styleElement.innerHTML = document.querySelector('[data-shop-pay-style]').innerHTML;
    spModal.shadowRoot?.prepend(styleElement)
  }
}, 1000);

// Articles
const articleH1s = document.querySelectorAll('.article-template__content h1');
articleH1s.forEach(h1 => {
  h1.outerHTML = h1.outerHTML.replaceAll('h1', 'h2');
});

/*----------- LEVER tracking ----------------*/
const leverTags = document.querySelectorAll(`[href="https://jobs.lever.co/heyrowan"]`);
leverTags.forEach(leverTag => {
  const params = new URLSearchParams(window.location.search);
  leverTag.href = `${leverTag.href}?` + params.toString();
});